import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL_2 || 'http://localhost:3001/api/guest';


export const createGuest = async (guestData) => {
  try {
    const response = await axios.post(`${API_URL}/create`, guestData, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};


export const getGuests = async (token) => {
  try {
    const response = await axios.get(`${API_URL}/list`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getGuestById = async (id, token) => {
  try {
    const response = await axios.get(`${API_URL}/show/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
